import {buildTypedMultiTabPanel} from '../../multi-tab-panel';
import {StudentsPanelTabID} from '../types';

export const {MultiTabPanel, useTabsContext} = buildTypedMultiTabPanel<StudentsPanelTabID>();
